import { useEffect } from 'react'

interface PageMetaOptions {
  title: string
  description?: string
  ogImage?: string
  canonical?: string
}

function setMetaTag(selector: string, attribute: 'name' | 'property', value: string) {
  let el = document.querySelector(`meta[${attribute}="${selector}"]`) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attribute, selector)
    document.head.appendChild(el)
  }
  el.content = value
}

export function usePageMeta({ title, description, ogImage, canonical }: PageMetaOptions) {
  useEffect(() => {
    const previousTitle = document.title
    document.title = title

    if (description) {
      setMetaTag('description', 'name', description)
      setMetaTag('og:description', 'property', description)
    }

    setMetaTag('og:title', 'property', title)
    setMetaTag('og:type', 'property', 'website')

    if (ogImage) {
      setMetaTag('og:image', 'property', ogImage)
    }

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
      if (!link) {
        link = document.createElement('link')
        link.rel = 'canonical'
        document.head.appendChild(link)
      }
      link.href = canonical
    }

    return () => {
      document.title = previousTitle
    }
  }, [title, description, ogImage, canonical])
}
